import React, { useState } from "react";
import { Transition } from "@headlessui/react";
import { useLocation, useNavigate } from "react-router-dom";
import Button from "../elements/Button";
import BrandIcon from "./BrandIcon";
import "../assets/css/header.css";

export default function Header() {
  const [isCollapse, setIsCollapse] = useState(false);
  const location = useLocation();
  const path = location.pathname;
  const navigate = useNavigate();

  const handleScrollToCompanies = (event) => {
    event.preventDefault(); // Prevents default anchor behavior

    if (location.pathname === "/") {
      // If already on LandingPage, scroll smoothly
      const section = document.getElementById("part3");
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      // If on another page, navigate to home first
      navigate("/#part3");
    }
  };

  return (
    <header className="header">
      <div className="flex justify-between px-4 lg:px-0">
        <BrandIcon />

        {/* Hamburger Menu Button */}
        <button
          className="block text-theme-green lg:hidden focus:outline-none"
          onClick={() => setIsCollapse(!isCollapse)} // Toggle collapse state
        >
          <svg
            className="w-8 h-8"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            {/* Hamburger Icon */}
            <path
              className={`${isCollapse ? "hidden" : "block"}`}
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M4 6h16M4 12h16m-7 6h7"
            />
            {/* Cross Icon */}
            <path
              className={`${!isCollapse ? "hidden" : "block"}`}
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>

      {/* Desktop Navigation */}
      <ul className="hidden text-theme-blue tracking-widest items-center lg:flex flex-row mt-0">
        <li>
          <Button
            className={`${
              path === "/" ? "active-link" : ""
            } font-medium  px-5 no-underline hover:underline`}
            type="link"
            href="/"
          >
            Home
          </Button>
        </li>
        <li>
          <Button
            className={`${
              path === "/aboutUs" ? "active-link" : ""
            } font-medium px-5 no-underline hover:underline`}
            type="link"
            href="/aboutUs"
          >
            About us
          </Button>
        </li>
        <li className="py-2 lg:py-0">
          <Button
            className={`${
              path === "/team" ? "active-link" : ""
            } font-medium px-5 no-underline hover:underline`}
            type="link"
            href="/team"
          >
            Our Team
          </Button>
        </li>
        <li>
          <Button
            className={`${
              path === "/" ? "active-link" : ""
            } font-medium px-5 no-underline hover:underline`}
            type="link"
            href="/#part3"
          >
            Our Companies
          </Button>
        </li>
        <li className="py-2 lg:py-0">
          <Button
            className={`${
              path === "/project" ? "active-link" : ""
            } font-medium px-5 no-underline hover:underline`}
            type="link"
            href="/project"
          >
            Our Services
          </Button>
        </li>
        <li className="py-2 lg:py-0">
          <Button
            className={`${
              path === "/customers" ? "active-link" : ""
            } font-medium px-5 no-underline hover:underline`}
            type="link"
            href="/customers"
          >
            Our Customers
          </Button>
        </li>
        <li>
          <Button
            className={`${
              path === "/discuss-project" ? "active-link" : ""
            } font-medium px-5 no-underline hover:underline`}
            type="link"
            href="/discuss-project"
          >
            Contact us
          </Button>
        </li>
      </ul>

      {/* Mobile Navigation (Hamburger Menu) */}
      <Transition
        show={isCollapse}
        enter="transition-opacity duration-300 ease-in-out"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="transition-opacity duration-300 ease-in-out"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <div className="lg:hidden bg-white w-full absolute top-16 left-0 z-50 border-t-2 border-gray-300">
          <ul className="flex flex-col text-theme-blue tracking-widest space-y-4 py-6">
            <li>
              <Button
                className={`${
                  path === "/" ? "active-link" : ""
                } font-medium px-10 no-underline hover:underline`}
                type="link"
                href="/"
              >
                Home
              </Button>
            </li>
            <li>
              <Button
                className={`${
                  path === "/aboutUs" ? "active-link" : ""
                } font-medium px-10 no-underline hover:underline`}
                type="link"
                href="/aboutUs"
              >
                About us
              </Button>
            </li>
            <li>
              <Button
                className={`${
                  path === "/team" ? "active-link" : ""
                } font-medium px-10 no-underline hover:underline`}
                type="link"
                href="/team"
              >
                Our Team
              </Button>
            </li>
            <li>
              <Button
                className={`${
                  path === "/#part3" ? "active-link" : ""
                } font-medium px-10 no-underline hover:underline`}
                type="link"
                href="/#part3"
              >
                Our Companies
              </Button>
            </li>
            <li>
              <Button
                className={`${
                  path === "/project" ? "active-link" : ""
                } font-medium px-10 no-underline hover:underline`}
                type="link"
                href="/project"
              >
                Our Services
              </Button>
            </li>
            <li>
              <Button
                className={`${
                  path === "/customers" ? "active-link" : ""
                } font-medium px-10 no-underline hover:underline`}
                type="link"
                href="/customers"
              >
                Our Customers
              </Button>
            </li>
            <li>
              <Button
                className={`${
                  path === "/discuss-project" ? "active-link" : ""
                } font-medium text-lg px-10 no-underline hover:underline`}
                type="link"
                href="/discuss-project"
              >
                Contact us
              </Button>
            </li>
          </ul>
        </div>
      </Transition>
    </header>
  );
}
